import React, { Component, Fragment } from 'react';
import axios from 'axios';
import {
    Icon,
    Segment,
    Loader,
    Input
} from 'semantic-ui-react';
import { ToastContainer } from 'react-toastify';
import PaginationFront from '../util/PaginationFront';
import { FormattedMessage } from 'react-intl';
import { sanitizeRichText, stripHtml } from '../util/richText';
import 'react-quill/dist/quill.snow.css';

class Announcements extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            data: [],
            results: [],
            loader: true,
            contentIndex: null,
            activePage: 1,
            postsPerPage: 5,
            searchValue: ''
        };

        this.fetchData = this.fetchData.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const locale = window.$locale;
        const bhs = locale === 'bs' || locale === 'sr' || locale === 'hr';

        axios.get('/announcement/by-user-type')
            .then(res => {
                this.setState({
                    data: res.data
                        .sort((a, b) => b.id - a.id)
                        .filter(el => el.title && el.content),
                    loader: false,
                    contentIndex: 0
                });
            })
            .catch(() => {
                this.setState({ loader: false });
            });
    }

    getDataToRender() {
        if (this.state.searchValue) {
            return this.state.results;
        }
        return this.state.data;
    }

    handleSearchChange(e, { value }) {
        const locale = window.$locale;
        const bhs = locale === 'bs' || locale === 'sr' || locale === 'hr';

        const filtered = this.state.data.filter(el => {
            const title = bhs ? (el.title || '') : (el.titleEng || '');
            const content = stripHtml(bhs ? (el.content || '') : (el.contentEng || ''));

            return (
                title.toLowerCase().includes(value.toLowerCase()) ||
                content.toLowerCase().includes(value.toLowerCase())
            );
        });

        this.setState({
            searchValue: value,
            results: value ? filtered : [],
            activePage: 1,
            contentIndex: 0
        });
    }

    handlePaginationChange(e, { activePage }) {
        this.setState({ activePage });
    }

    formatDate(dateValue) {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return '';
        return `${String(date.getDate()).padStart(2, '0')}. ${String(date.getMonth() + 1).padStart(2, '0')}. ${date.getFullYear()}.`;
    }

    formatCreatorRole(role) {
        const roleMessageIds = {
            administrator: 'announcements.roleAdministrator',
            aida: 'announcements.roleAida',
            international_cooperation_office: 'announcements.roleInternationalCooperationOffice'
        };

        const id = roleMessageIds[role];
        return id ? <FormattedMessage id={id} /> : role;
    }

    render() {
        const locale = window.$locale;
        const bhs = locale === 'bs' || locale === 'sr' || locale === 'hr';
        const activeRole = localStorage.getItem('activeRole') || '';
        const showCreatorUsername = activeRole.substr(0, 13) === 'Administrator' || activeRole === 'AIDA';

        const allPosts = this.getDataToRender();
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = allPosts.slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                {this.state.loader ? (
                    <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                        <Loader active inline="centered" />
                    </div>
                ) : (
                    <Fragment>

                        {/* SEARCH */}
                        <div style={{ width: '100%', marginBottom: '25px' }}>
                            <FormattedMessage id="announcements.searchPlaceholder">
                                {(msg) => (<Input
                                    fluid
                                    icon="search"
                                    placeholder={msg}
                                    value={this.state.searchValue}
                                    onChange={this.handleSearchChange}
                                    size="large"
                                />)}
                            </FormattedMessage>
                        </div>

                        {/* NO RESULTS */}
                        {allPosts.length === 0 ? (
                            <FormattedMessage id="announcements.noAnnouncements" />
                        ) : (
                            <Fragment>
                                {currentPosts.map((el, index) => {
                                    const absoluteIndex = indexOfFirstPost + index;
                                    const isOpen = absoluteIndex === this.state.contentIndex;

                                    return (
                                        <Segment
                                            key={el.id}
                                            onClick={() => {
                                                this.setState({
                                                    contentIndex: isOpen ? null : absoluteIndex
                                                });
                                            }}
                                            style={{
                                                position: 'relative',
                                                borderLeft: isOpen ? '4px solid #14b8a6' : '4px solid #2185d0',
                                                marginBottom: '18px',
                                                padding: '18px 26px',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                                transition: 'all 0.2s ease',
                                                backgroundColor: '#fff'
                                            }}
                                        >


                                            {/* TITLE + ICON */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    minHeight: '24px'
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        color: '#000',
                                                        fontWeight: 700,
                                                        lineHeight: 1.25,
                                                        fontSize: '18px',
                                                        flex: 1,
                                                        marginTop: '-4px'
                                                    }}
                                                >
                                                    {bhs ? el.title : (el.titleEng || el.title)}
                                                </div>

                                                <Icon
                                                    name={isOpen ? 'angle up' : 'angle down'}
                                                    style={{
                                                        marginLeft: '10px',
                                                        marginTop: '-4px',
                                                        color: '#1d2d50'
                                                    }}
                                                />
                                            </div>
                                            {/* DATE */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    fontSize: '12px',
                                                    fontWeight: 700,
                                                    color: 'grey',
                                                    marginTop: '6px',
                                                    marginBottom: '10px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.4px',
                                                    lineHeight: 1
                                                }}
                                            >
                                                <Icon
                                                    name="calendar alternate outline"
                                                    style={{
                                                        color: '#14b8a6',
                                                        fontSize: '12px',
                                                        margin: 0,
                                                        lineHeight: 1,
                                                        display: 'block'
                                                    }}
                                                />
                                                <span style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
                                                        {this.formatDate(el.date || el.createdAt || el.creationDate)}
                                                    </span>
                                                {el.createdByRole && (
                                                    <span style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        lineHeight: 1,
                                                        textTransform: 'none'
                                                    }}>
                                                        <Icon name="user outline" style={{ marginLeft: '8px' }} />
                                                        <span>
                                                            {this.formatCreatorRole(el.createdByRole)}
                                                            {showCreatorUsername && el.createdByUsername &&
                                                                el.createdByRole !== 'administrator' &&
                                                                el.createdByRole !== 'Administrator' &&
                                                                ` (${el.createdByUsername})`}
                                                        </span>
                                                    </span>
                                                )}
                                            </div>

                                            {/* CONTENT */}
                                            {isOpen && (
                                                <div
                                                    className="ql-editor"
                                                    style={{
                                                        marginTop: '18px',
                                                        paddingTop: '16px',
                                                        borderTop: '1px solid #ececec',
                                                        lineHeight: 1.7,
                                                        color: '#444',
                                                        whiteSpace: 'normal',
                                                        textAlign: 'justify'
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: sanitizeRichText(bhs ? el.content : (el.contentEng || el.content))
                                                    }}
                                                />
                                            )}
                                        </Segment>
                                    );
                                })}
                            </Fragment>
                        )}

                        {/* PAGINATION */}
                        {currentPosts.length > 0 && (
                            <PaginationFront
                                postsPerPage={this.state.postsPerPage}
                                totalPosts={allPosts.length}
                                paginate={this.handlePaginationChange}
                                activePage={this.state.activePage}
                            />
                        )}

                    </Fragment>
                )}

                <ToastContainer />
            </div>
        );
    }
}

export default Announcements;



// WEBPACK FOOTER //
// ./src/views/Announcements/Announcements.js